import {
  GCS_PATH_IDS,
  getImageKeyFromPath,
  requestAccess,
  uploadFileGcs,
} from '~/common/storage/gcs_storage';
import {api} from '~/ViewInvitation/api/api';

/**
 * Uploads a file to gcs and return the photo ID
 * @param eventId
 * @param guestId
 * @param photo
 * @param progressCb callback to report progress
 * @param width photo width
 * @param height photo height
 * @returns int photo ID
 */
export const uploadPhoto = async ({
  eventId,
  guestId,
  photo,
  // biome-ignore lint/suspicious/noEmptyBlockStatements: existing error
  progressCb = () => {},
  width,
  height,
  isHostModule,
}) => {
  const path = isHostModule ? GCS_PATH_IDS.host_gallery_photos : GCS_PATH_IDS.feed_photos;
  const params = {
    // biome-ignore lint/style/useNamingConvention: existing error
    event_id: eventId,
    // biome-ignore lint/style/useNamingConvention: existing error
    photo_id: '',
    // biome-ignore lint/style/useNamingConvention: existing error
    guest_id: guestId,
  };

  const body = {redirect: true, mimetype: photo.file.type, width, height};
  const uploadRequest = await requestAccess(path, params, body);
  const success = await uploadFileGcs(uploadRequest, photo.file, progressCb);
  return success ? getImageKeyFromPath(uploadRequest.gcs_path) : null;
};

export const PHOTO_API_TAGS = Object.freeze({
  HOST: 'HostPhoto',
  SHARED: 'Photo',
});

export const invalidateTag = (isHostModule) =>
  api.util.invalidateTags([isHostModule ? PHOTO_API_TAGS.HOST : PHOTO_API_TAGS.SHARED]);
